<template>
    <div>
        <!--
        <div class="mx-auto" ref="original" style="background-color:lightgray;height:300px; width:700px"></div>
        <div class="mt-4 mx-auto" ref="other" style="background-color:lightgray;height:300px; width:700px"></div>
        -->

        <div class="mt-4 mx-auto">
            <b>Kép párosítás száma:</b> {{ task.taskable.image_gallery.length }} <br>
            <b>Eltalált párosítás:</b> {{ successPairing }}
        </div>
    </div>
</template>
<script>
import {filter} from "lodash";

export default {
    props: {
        userTask: {
            type: Object,
            required: true,
        },
        task: {
            type: Object,
            required: true,
        },
    },
    methods: {
        initCanvas(ref) {
            let mydiv = this.$refs[ref];
            mydiv.style.position = "relative";
            let height = parseInt(mydiv.style.height, 10);
            let width = parseInt(mydiv.style.width, 10);

            let canimg = document.createElement("canvas");
            canimg.height = height - 40;
            canimg.width = width;
            canimg.setAttribute("style", "position:absolute;top:0;left:0;z-index:0;");
            let ctxi = canimg.getContext("2d");
            ctxi.font = "12pt Arial";
            mydiv.appendChild(canimg);

            let candraw = document.createElement("canvas");
            candraw.height = height - 40;
            candraw.width = width;
            candraw.setAttribute("style", "position:absolute;top:0;left:0;z-index:1;");

            let ctxd = candraw.getContext("2d");
            ctxd.storkeStyle = 'black';
            ctxd.lineWidth = 3;
            mydiv.appendChild(candraw);
        },
    },
    computed: {
        successPairing() {
            return filter(this.userTask.solution.images[0], (image) => {
                return image.status === true;
            }).length;
        }
    },
    mounted() {
        //this.initCanvas('original');
        //this.initCanvas('other');
    }
}
</script>
